import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { withStyles, MuiThemeProvider } from '@material-ui/core/styles';
import ReactRouterPropTypes from 'react-router-prop-types';
import { CssBaseline } from '@material-ui/core';
import customTheme from './customTheme';
import AppBar from '../AppBar/AppBar';
import ErrorMessages from '../ErrorMessages/ErrorMessages';
import Settings from '../../Settings/Settings';
import translation from '../../../translation/translation';
import routeConstants from '../../../Routes/routeConstants';
import Help from '../../Help/Help';

const styles = () => ({
    root: {
        display: 'flex',
        width: '100%',
        minWidth: 320,
        flexWrap: 'wrap',
        '@media print': {
            display: 'block',
            position: 'relative',
        },
    },
    content: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexGrow: 1,
        minHeight: '70vh',
        maxWidth: '100%',
        '@media print': {
            display: 'block',
            position: 'relative',
        },
    },
});

const PageRootWrapper = ({
    children,
    classes,
    withAppBar,
    location,
    location: { pathname },
}) => {
    const userPreferedLanguage = useSelector(state => state.user.preferedLanguage);
    const userDarkMode = useSelector(state => state.user.darkMode);
    const loggedIn = useSelector(state => state.user.loggedIn);

    const language = translation(userPreferedLanguage);

    return (
        <MuiThemeProvider theme={customTheme(userDarkMode)}>
            <CssBaseline />
            <div className={classes.root}>
                { !loggedIn && pathname !== routeConstants.LOGIN && (
                    <Redirect to={{ pathname: routeConstants.LOGIN, state: { from: location } }} />)
                }
                { withAppBar && (
                    <AppBar
                        translation={language}
                        location={location}
                    />
                )
                }
                <div className={classes.content}>
                    {React.cloneElement(
                        children,
                        { translation: language },
                    )}
                </div>
                <ErrorMessages />
                <Settings
                    translation={language}
                />
                <Help
                    translation={language}
                />
            </div>
        </MuiThemeProvider>
    );
};

PageRootWrapper.propTypes = {
    classes: PropTypes.objectOf(PropTypes.any).isRequired,
    location: ReactRouterPropTypes.location.isRequired,
    withAppBar: PropTypes.bool,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
};

PageRootWrapper.defaultProps = {
    withAppBar: true,
};

export default withStyles(styles)(PageRootWrapper);
